import { map } from 'lodash-es';
import numberMixin from '../../../../mixins/numberMixin';

export default {

  /**
   * @param state
   * @param getters
   * @param rootState
   * @param rootGetters
   * @returns {Array}
   */
  getSkiRentalsWithProducts(state, getters, rootState, rootGetters) {
    const stateRentalsWithProducts = state.rentals.items;
    const stateParticipants = rootGetters['booking/getParticipantsWithFullName'];
    const stateBookingStaysWithArea = rootGetters['booking/getBookingStaysWithArea'];
    if (!stateParticipants
      || !stateParticipants.length
      || !stateRentalsWithProducts
      || !stateRentalsWithProducts.length
      || !stateBookingStaysWithArea
      || !stateBookingStaysWithArea.length
    ) {
      return [];
    }
    const selectedBookingParticipantId = state.search.selectedBookingParticipant;
    const selectedAreaId = state.search.selectedAreaId;
    const rentalsWithProducts = stateRentalsWithProducts.filter(
      rentalWithProducts =>
        rentalWithProducts.bookingParticipantId === selectedBookingParticipantId
        || !selectedBookingParticipantId,
    ).map((rentalWithProducts) => {
      const participant = stateParticipants.find(stateParticipant =>
        stateParticipant.id === rentalWithProducts.bookingParticipantId,
      );
      const area = rootState.booking.areas.items.find(stateArea => stateArea.id === rentalWithProducts.areaId);
      const skiRentalProducts = rentalWithProducts.skiRentalProducts.map((rentalProduct) => {
        let statusColor;
        let statusIcon;
        switch (rentalProduct.status) {
          case 'paid':
            statusColor = 'green';
            statusIcon = 'check_circle';
            break;
          case 'cancelled':
          case 'stopped':
            statusColor = 'red';
            statusIcon = 'warning';
            break;
          default:
            statusColor = 'orange';
            statusIcon = 'watch_later';
            break;
        }
        let statusName = rentalProduct.status;
        if (statusName === 'initiated') {
          statusName = 'Not paid';
        }
        const priceGross = rentalProduct.price;
        const priceNet = rentalProduct.priceNet;
        let totalGrossAfterDiscount = priceGross;
        let totalNetAfterDiscount = priceNet;
        let discountPercentage;
        let discountGross;
        let discountNet;
        if (rentalProduct.discount !== null && rentalProduct.discountNet !== null) {
          discountPercentage = numberMixin.filters.roundNumber(
            (rentalProduct.discount / priceGross) / 100,
          );
          discountGross = rentalProduct.discount;
          discountNet = rentalProduct.discountNet;
          totalGrossAfterDiscount -= rentalProduct.discount;
          totalNetAfterDiscount -= rentalProduct.discountNet;
          totalGrossAfterDiscount = numberMixin.filters.roundNumber(totalGrossAfterDiscount, 0);
          totalNetAfterDiscount = numberMixin.filters.roundNumber(totalNetAfterDiscount, 0);
        }

        return {
          ...rentalProduct,
          statusName,
          statusColor,
          statusIcon,
          discountPercentage: numberMixin.filters.roundNumber(discountPercentage),
          priceGross: numberMixin.filters.roundNumber(priceGross),
          priceNet: numberMixin.filters.roundNumber(priceNet),
          discountGross: numberMixin.filters.roundNumber(discountGross),
          discountNet: numberMixin.filters.roundNumber(discountNet),
          totalGrossAfterDiscount: numberMixin.filters.roundNumber(totalGrossAfterDiscount),
          totalNetAfterDiscount: numberMixin.filters.roundNumber(totalNetAfterDiscount),
          // TODO: SKI-1127 Find person category ages and check booking participant age is valid
          ageMismatch: false,
        };
      });
      const isAllPersonInformationFilledOut = rentalWithProducts.height > 0
        && rentalWithProducts.weight > 0
        && rentalWithProducts.shoeSize > 0
        && participant
        && participant.validBirthday;

      return {
        id: rentalWithProducts.id,
        bookingId: rentalWithProducts.bookingId,
        bookingParticipantId: rentalWithProducts.bookingParticipantId,
        area,
        height: rentalWithProducts.height,
        weight: rentalWithProducts.weight,
        shoeSize: rentalWithProducts.shoeSize,
        skiRentalProducts,
        participant,
        isAllPersonInformationFilledOut,
        xmlChannelProductIds: rentalWithProducts.xmlChannelProductIds,
      };
    });
    return rentalsWithProducts.filter(
      rentalWithProducts => rentalWithProducts.area.id === selectedAreaId
        || !selectedAreaId,
    ).sort((a, b) => a.bookingParticipantId - b.bookingParticipantId);
  },

  /**
   * @param state
   * @param getters
   * @param rootState
   * @param rootGetters
   * @returns {Array|*}
   */
  getBookingParticipantsWhereRentalsExist(state, getters, rootState, rootGetters) {
    const stateRentalsWithProducts = state.rentals.items;
    const stateParticipants = rootGetters['booking/getParticipantsWithFullName'];
    if (!stateParticipants
      || !stateParticipants.length
      || !stateRentalsWithProducts
      || !Object.keys(stateRentalsWithProducts).length
    ) {
      return [];
    }
    const allBookingParticipantIds = stateRentalsWithProducts.filter(
      stateRentalWithProduct => stateRentalWithProduct.skiRentalProducts.length,
    ).map(
      stateRentalWithProducts => stateRentalWithProducts.bookingParticipantId,
    );
    const uniqueBookingParticipantIds = [...new Set(allBookingParticipantIds)];
    const availableParticipants = stateParticipants.filter(stateParticipant =>
      uniqueBookingParticipantIds.includes(stateParticipant.id),
    );
    const selectAllItem = {
      fullName: 'Select all',
      id: null,
    };

    return [
      selectAllItem,
      ...availableParticipants,
    ];
  },

  /**
   * @param state
   * @param getters
   * @param rootState
   * @param rootGetters
   * @returns {Array|*[]}
   */
  getBookingStayAreasWithAllOption(state, getters, rootState, rootGetters) {
    const stateBookingStayAreas = rootGetters['booking/getBookingStayAreas'];
    if (!stateBookingStayAreas || !stateBookingStayAreas.length) {
      return [];
    }
    const selectAllItem = {
      name: 'Select all',
      id: null,
    };

    return [
      selectAllItem,
      ...stateBookingStayAreas,
    ];
  },

  /**
   * @param state
   * @param getters
   * @returns {undefined|*}
   */
  getAvailableSkiRentalProductUsedForChangeProduct(state, getters) {
    const stateAvailableRentalProducts = state.availableRentalProducts.items;
    const selectedStartDate = state.changeProduct.selectedStartDate;
    if (!selectedStartDate
      || !stateAvailableRentalProducts
      || !stateAvailableRentalProducts.length
    ) {
      return undefined;
    }
    const availableRentalProducts = getters.filterAvailableRentalProductsByAllFilters(state);
    for (let i = 0; i < availableRentalProducts.length; i += 1) {
      let availableRentalProduct = availableRentalProducts[i];
      const priceGross = availableRentalProduct.priceDay.priceGross;
      const priceNet = availableRentalProduct.priceDay.priceNet;
      let totalGrossAfterDiscount = priceGross;
      let totalNetAfterDiscount = priceNet;
      let discountGross;
      let discountNet;
      if (availableRentalProduct.discount && availableRentalProduct.discount.id) {
        const discountPercentage = availableRentalProduct.discount.percentage / 100;
        discountGross = priceGross * discountPercentage;
        discountNet = priceNet * discountPercentage;
        totalGrossAfterDiscount -= discountGross;
        totalNetAfterDiscount -= discountNet;
      }
      availableRentalProduct = {
        ...availableRentalProduct,
        priceGross: numberMixin.filters.roundNumber(priceGross, 0),
        priceNet: numberMixin.filters.roundNumber(priceNet, 0),
        discountGross: numberMixin.filters.roundNumber(discountGross, 0),
        discountNet: numberMixin.filters.roundNumber(discountNet, 0),
        totalGrossAfterDiscount: numberMixin.filters.roundNumber(totalGrossAfterDiscount, 0),
        totalNetAfterDiscount: numberMixin.filters.roundNumber(totalNetAfterDiscount, 0),
      };

      return availableRentalProduct;
    }

    return undefined;
  },

  /**
   * @param state
   * @param getters
   * @returns {this|Array}
   */
  getAvailableSkiRentalProducts(state, getters) {
    const stateAvailableRentalProducts = state.availableRentalProducts.items;
    const selectedStartDate = state.search.selectedStartDate;
    if (!selectedStartDate
      || !stateAvailableRentalProducts
      || !stateAvailableRentalProducts.length
    ) {
      return [];
    }
    const currentBookingRentalProducts
      = getters.getBookingRentalProductsBySelectedBookingParticipant(state);
    const availableRentalProducts = getters.filterAvailableRentalProducts(state);
    const defaultPersonCategories = getters.uniquePersonCategoriesFromAvailableSkiRentalProducts(
      state,
      getters,
    );
    const productsGrouped = {};
    for (let i = 0; i < availableRentalProducts.length; i += 1) {
      const availableRentalProduct = availableRentalProducts[i];
      const levelId = availableRentalProduct.level.id;
      const skiTypeId = availableRentalProduct.skiType.id;
      const skiPackageId = availableRentalProduct.package.id;
      const personCategoryId = availableRentalProduct.personCategory.id;
      const prices = {};
      for (let k = 0; k < defaultPersonCategories.length; k += 1) {
        const defaultPersonCategory = defaultPersonCategories[k];
        if (prices[defaultPersonCategory.id] === undefined) {
          prices[defaultPersonCategory.id] = {};
        }
        let availableRentalProductId;
        let availableRentalProductName;
        let availableRentalProductExternalName;
        let availableRentalProductPriceDay;
        let availableRentalProductPersonCategory;
        let availableRentalProductDiscount;
        let bookingRentalProductId;
        if (defaultPersonCategory.id === personCategoryId) {
          availableRentalProductId = availableRentalProduct.id;
          availableRentalProductName = availableRentalProduct.name;
          availableRentalProductExternalName = availableRentalProduct.externalName;
          availableRentalProductPriceDay = availableRentalProduct.priceDay;
          availableRentalProductPersonCategory = availableRentalProduct.personCategory;
          availableRentalProductDiscount = availableRentalProduct.discount;
          const foundBookingRentalProduct = currentBookingRentalProducts.find(
            bookingRentalProduct =>
              bookingRentalProduct.seasonId === availableRentalProduct.season.id
              && bookingRentalProduct.skiTypeId === skiTypeId
              && bookingRentalProduct.packageId === skiPackageId
              && bookingRentalProduct.personCategoryId === personCategoryId
              && bookingRentalProduct.levelId === levelId
              && bookingRentalProduct.days === availableRentalProduct.priceDay.days
              && bookingRentalProduct.firstSkiDay === selectedStartDate,
          );
          if (foundBookingRentalProduct) {
            bookingRentalProductId = foundBookingRentalProduct.id;
          }
        }
        const priceGross = availableRentalProduct.priceDay.priceGross;
        const priceNet = availableRentalProduct.priceDay.priceNet;
        let totalGrossAfterDiscount = priceGross;
        let totalNetAfterDiscount = priceNet;
        if (availableRentalProduct.discount && availableRentalProduct.discount.id) {
          const discountPercentage = availableRentalProduct.discount.percentage / 100;
          const discountGross = numberMixin.filters.roundNumber(priceGross * discountPercentage, 0);
          const discountNet = numberMixin.filters.roundNumber(priceNet * discountPercentage, 0);
          totalGrossAfterDiscount -= discountGross;
          totalNetAfterDiscount -= discountNet;
        }
        prices[defaultPersonCategory.id] = {
          id: availableRentalProductId,
          bookingRentalProductId,
          name: availableRentalProductName,
          externalName: availableRentalProductExternalName,
          priceGross: numberMixin.filters.roundNumber(priceGross, 0),
          priceNet: numberMixin.filters.roundNumber(priceNet, 0),
          totalGrossAfterDiscount: numberMixin.filters.roundNumber(totalGrossAfterDiscount, 0),
          totalNetAfterDiscount: numberMixin.filters.roundNumber(totalNetAfterDiscount, 0),
          hasDiscount: availableRentalProduct.discount && availableRentalProduct.discount.id > 0,
          priceDay: availableRentalProductPriceDay,
          personCategory: availableRentalProductPersonCategory,
          discount: availableRentalProductDiscount,
        };
      }
      const level = {
        ...availableRentalProduct.level,
        prices,
      };
      let levels = {};
      if (productsGrouped[`${skiTypeId}-${skiPackageId}`] === undefined) {
        productsGrouped[`${skiTypeId}-${skiPackageId}`] = {};
      } else if (productsGrouped[`${skiTypeId}-${skiPackageId}`].levels[levelId] !== undefined) {
        const mergedPrices = {};
        const foundLevel = productsGrouped[`${skiTypeId}-${skiPackageId}`].levels[levelId];
        Object.entries(foundLevel.prices).forEach(([pricePersonCategoryId, price]) => {
          if (price.id === undefined) {
            const newPrice = prices[personCategoryId];
            if (newPrice) {
              mergedPrices[personCategoryId] = newPrice;
            }
          } else {
            mergedPrices[pricePersonCategoryId] = price;
          }
        });
        level.prices = mergedPrices;
      } else {
        levels = productsGrouped[`${skiTypeId}-${skiPackageId}`].levels;
      }
      levels[levelId] = level;
      productsGrouped[`${skiTypeId}-${skiPackageId}`] = {
        skiType: availableRentalProduct.skiType,
        package: availableRentalProduct.package,
        season: availableRentalProduct.season,
        levels,
      };
    }

    return productsGrouped;
  },

  /**
   * @param state
   * @returns {{totalGross: *, totalNet: *}}
   */
  getSkiRentalsTotalPrice(state) {
    const stateRentalsWithProducts = state.rentals.items;
    let totalGross = 0;
    let totalNet = 0;
    Object.values(stateRentalsWithProducts).forEach((rentalWithProducts) => {
      Object.values(rentalWithProducts.skiRentalProducts).forEach((rentalProduct) => {
        if (!rentalProduct.deletedAt && !rentalProduct.cancelledAt && !rentalProduct.stoppedAt) {
          let priceGross = rentalProduct.price;
          let priceNet = rentalProduct.priceNet;
          if (rentalProduct.discount) {
            priceGross -= rentalProduct.discount;
            priceNet -= rentalProduct.discountNet;
          }
          totalGross += priceGross;
          totalNet += priceNet;
        }
      });
    });

    return {
      totalGross: numberMixin.filters.roundNumber(totalGross),
      totalNet: numberMixin.filters.roundNumber(totalNet),
    };
  },

  /**
   * @param state
   * @returns {number}
   */
  getTotalNumberOfSkiRentalProducts(state) {
    const stateRentalsWithProducts = state.rentals.items;
    let totalNumberOfSkiRentalProducts = 0;
    Object.values(stateRentalsWithProducts).forEach((rental) => {
      totalNumberOfSkiRentalProducts += rental.skiRentalProducts.length;
    });

    return totalNumberOfSkiRentalProducts;
  },

  /**
   * @param state
   * @returns {Array|*[]}
   */
  getAvailableSkiTypesUsedForChangeProduct(state) {
    const stateAvailableRentalProducts = state.availableRentalProducts.items;
    if (!stateAvailableRentalProducts || !stateAvailableRentalProducts.length) {
      return [];
    }
    const selectedPersonCategoryId = state.changeProduct.selectedPersonCategoryId;
    const allSkiTypes = state.skiTypes.items;
    const availableSkiTypeIds = stateAvailableRentalProducts.filter(
      product => product.personCategory.id === selectedPersonCategoryId,
    ).map(
      product => product.skiType.id,
    );
    const uniqueSkiTypeIds = [...new Set(availableSkiTypeIds)];

    return allSkiTypes.filter(skiType =>
      uniqueSkiTypeIds.includes(skiType.id),
    );
  },

  /**
   * @param state
   * @returns {Array|*[]}
   */
  getAvailableLevelTypesUsedForChangeProduct(state) {
    const stateAvailableRentalProducts = state.availableRentalProducts.items;
    if (!stateAvailableRentalProducts || !stateAvailableRentalProducts.length) {
      return [];
    }
    const selectedPersonCategoryId = state.changeProduct.selectedPersonCategoryId;
    const selectedSkiTypeId = state.changeProduct.selectedSkiTypeId;
    const allLevelTypes = state.levelTypes.items;
    const availableLevelTypeIds = stateAvailableRentalProducts.filter(
      product => product.personCategory.id === selectedPersonCategoryId
        && product.skiType.id === selectedSkiTypeId,
    ).map(
      product => product.level.id,
    );
    const uniqueLevelTypeIds = [...new Set(availableLevelTypeIds)];

    return allLevelTypes.filter(levelType =>
      uniqueLevelTypeIds.includes(levelType.id),
    );
  },

  /**
   * @param state
   * @returns {Array|*[]}
   */
  getAvailablePackageTypesUsedForChangeProduct(state) {
    const stateAvailableRentalProducts = state.availableRentalProducts.items;
    if (!stateAvailableRentalProducts || !stateAvailableRentalProducts.length) {
      return [];
    }
    const selectedPersonCategoryId = state.changeProduct.selectedPersonCategoryId;
    const selectedSkiTypeId = state.changeProduct.selectedSkiTypeId;
    const selectedLevelTypeId = state.changeProduct.selectedLevelTypeId;
    const allPackageTypes = state.packageTypes.items;
    const availablePackageTypeIds = stateAvailableRentalProducts.filter(
      product => product.personCategory.id === selectedPersonCategoryId
        && product.skiType.id === selectedSkiTypeId
        && product.level.id === selectedLevelTypeId,
    ).map(
      product => product.package.id,
    );
    const uniquePackageTypeIds = [...new Set(availablePackageTypeIds)];

    return allPackageTypes.filter(packageType =>
      uniquePackageTypeIds.includes(packageType.id),
    );
  },

  /**
   * @param state
   * @param getters
   * @returns {this|Array}
   */
  getAvailableSkiRentalProductsPersonCategoryHeaders(state, getters) {
    const stateAvailableRentalProducts = state.availableRentalProducts.items;
    if (!stateAvailableRentalProducts || !stateAvailableRentalProducts.length) {
      return [];
    }

    return getters.uniquePersonCategoriesFromAvailableSkiRentalProducts(state, getters);
  },

  /**
   * @returns {Function}
   */
  getBookingRentalProductsBySelectedBookingParticipant: () => (state) => {
    const selectedBookingParticipantId = state.search.selectedBookingParticipantId;
    const stateRentalProducts = state.rentals.items;
    if (!selectedBookingParticipantId || !stateRentalProducts.length) {
      return [];
    }
    const rentalProduct = stateRentalProducts.find(item =>
      item.bookingParticipantId === selectedBookingParticipantId,
    );
    if (!rentalProduct) {
      return [];
    }

    return map(rentalProduct.skiRentalProducts, skiRentalProduct => ({
      id: skiRentalProduct.id,
      seasonId: skiRentalProduct.productsSkiRentalSeasonId,
      skiTypeId: skiRentalProduct.productsSkiRentalSkiTypeId,
      packageId: skiRentalProduct.productsSkiRentalPackageId,
      personCategoryId: skiRentalProduct.productsSkiRentalPersonCategoryId,
      levelId: skiRentalProduct.productsSkiRentalLevelId,
      firstSkiDay: skiRentalProduct.firstSkiDay,
      days: skiRentalProduct.numberOfDays,
    }));
  },

  /**
   * @returns {Function}
   */
  uniquePersonCategoriesFromAvailableSkiRentalProducts: () => (state, getters) => {
    const stateAvailableRentalProducts = state.availableRentalProducts.items;
    if (!stateAvailableRentalProducts || !stateAvailableRentalProducts.length) {
      return [];
    }
    const availableRentalProducts = getters.filterAvailableRentalProducts(state);
    const uniquePersonCategories = [];
    for (let i = 0; i < availableRentalProducts.length; i += 1) {
      const availableRentalProduct = availableRentalProducts[i];
      if (!uniquePersonCategories.some(personCategoryHeader =>
        personCategoryHeader.id === availableRentalProduct.personCategory.id,
      )) {
        uniquePersonCategories.push(availableRentalProduct.personCategory);
      }
    }

    return uniquePersonCategories;
  },

  /**
   * @returns {Function}
   */
  filterAvailableRentalProducts: () => (state) => {
    const stateAvailableRentalProducts = state.availableRentalProducts.items;
    if (!stateAvailableRentalProducts || !stateAvailableRentalProducts.length) {
      return [];
    }
    const selectedLevelIds = state.search.selectedMultipleLevelTypes;
    const selectedSkiTypeIds = state.search.selectedMultipleSkiTypes;

    return stateAvailableRentalProducts.filter(availableRentalProduct => (
      (!selectedLevelIds.length || selectedLevelIds.includes(availableRentalProduct.level.id))
      && (!selectedSkiTypeIds.length
        || selectedSkiTypeIds.includes(availableRentalProduct.skiType.id)
      )
    ));
  },

  /**
   * @returns {Function}
   */
  filterAvailableRentalProductsByAllFilters: () => (state) => {
    const stateAvailableRentalProducts = state.availableRentalProducts.items;
    if (!stateAvailableRentalProducts || !stateAvailableRentalProducts.length) {
      return [];
    }
    const selectedPersonCategoryId = state.changeProduct.selectedPersonCategoryId;
    const selectedNumberOfDays = state.changeProduct.selectedNumberOfDays;
    const selectedLevelTypeId = state.changeProduct.selectedLevelTypeId;
    const selectedSkiTypeId = state.changeProduct.selectedSkiTypeId;
    const selectedPackageTypeId = state.changeProduct.selectedPackageTypeId;

    return stateAvailableRentalProducts.filter(availableRentalProduct => (
      selectedPersonCategoryId === availableRentalProduct.personCategory.id
      && selectedNumberOfDays === availableRentalProduct.priceDay.days
      && selectedLevelTypeId === availableRentalProduct.level.id
      && selectedSkiTypeId === availableRentalProduct.skiType.id
      && selectedPackageTypeId === availableRentalProduct.package.id
    ));
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/ski/rental/getters.js